import React, { FC } from 'react';

import { colorOpacity, customTheme } from 'theme';

import { PrimaryButton } from 'components/DataEntry';
import { PrimaryButtonProps } from 'components/DataEntry/Button/types';

interface Props extends PrimaryButtonProps {}

export const OutlinedIconButton: FC<Props> = props => {
  return (
    <PrimaryButton
      _hover={{
        bg: colorOpacity(customTheme.colors.primary, 0.2),
      }}
      _focus={{ bg: colorOpacity(customTheme.colors.primary, 0.2) }}
      _active={{ bg: colorOpacity(customTheme.colors.primary, 0.2) }}
      bg="none"
      fontSize="17px"
      border="none"
      color="#000"
      iconColor="#000"
      iconSize={6}
      px={2}
      iconSpacing={2}
      {...props}
    >
      {props.children}
    </PrimaryButton>
  );
};
